import comprasAssinaturas from './comprasAssinaturas.routes';
import reembolso from './reembolso.routes';
import rastreio from './rastreio.routes';
import chat from './chat.routes';

const routes = [
  ...comprasAssinaturas,
  ...reembolso,
  ...rastreio,
  ...chat,
];

export default routes;
